import { Navigate, useRoutes } from 'react-router-dom';

import { CONFIG } from 'src/config-global';

import { authRoutes } from './auth';
import { mainRoutes } from './main';
import { dashboardRoutes, IRoute } from './dashboard';
import { TenantNotFoundLayout } from 'src/layouts/main';
import { SplashScreen } from 'src/components/loading-screen';
import { lazy, Suspense, useCallback, useMemo } from 'react';
import { useCurrentTenantContext } from 'src/current-tenant';

// ----------------------------------------------------------------------

// Error
const TenantNotFoundPage = lazy(
  () => import('src/pages/error/tenant-not-found'),
);

export function Router() {
  const { modules } = useCurrentTenantContext();

  // Filter routes based on the modules
  const isAllowed = useCallback(
    (route: IRoute) => {
      if (route.children) {
        route.children =
          route.children.filter((child: IRoute) => isAllowed(child)) || [];
      }
      return !route.module || modules.includes(route.module);
    },
    [modules],
  );

  const filteredDashboardRoutes: any[] = useMemo(() => {
    return dashboardRoutes.filter((route: any) => isAllowed(route));
  }, [modules]);

  return useRoutes([
    // Main
    ...mainRoutes,

    // Auth
    ...authRoutes,

    // Dashboard
    ...filteredDashboardRoutes,

    // Tenant not found
    {
      path: 'tenant-not-found',
      element: (
        <TenantNotFoundLayout>
          <Suspense fallback={<SplashScreen />}>
            <TenantNotFoundPage />
          </Suspense>
        </TenantNotFoundLayout>
      ),
    },

    // No match
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
